module.exports = __webpack_public_path__ + "static/img/icon11.5392945a.png";